// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* auth-wrap and auth-card are defined globally in styles.css */
`, "",{"version":3,"sources":["webpack://./src/app/components/adopt-identity-login/adopt-identity-login.component.css"],"names":[],"mappings":"AAAA,+DAA+D","sourcesContent":["/* auth-wrap and auth-card are defined globally in styles.css */\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
